import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import type { User } from "./api";
import { isChunkError, reloadForChunk } from "./chunk";
import { Localized } from "./i18n/Localized";
// Pretendard, the Optra Prism console's one typeface, in unicode-range
// slices so a page loads only the glyphs it shows (OFL-1.1)
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);
const app = (key = 0, keepsNext = true, onDemo?: (user: User) => void | Promise<unknown>) => (
  <StrictMode>
    <Localized render={() => <App key={key} keepsNext={keepsNext} onDemo={onDemo} />} />
  </StrictMode>
);

// a demo account signed in (byj-1wv.84.1) is handed to the demo, which
// answers the app itself in this page: a chunk of its own, so no other page
// carries it; once, though StrictMode runs the app's effects twice. A chunk a
// newer build replaced reloads the page once (src/chunk); any other failure,
// loading it or starting it, is the app's to say, whose Retry reloads the page
let demoStarted = false;
const demo = (user: User) => {
  if (demoStarted) return;
  demoStarted = true;
  return import("./demo/boot")
    .then((d) => {
      d.boot(root, app, user);
    })
    .catch((err: unknown) => {
      if (isChunkError(err) && reloadForChunk()) return new Promise<void>(() => {});
      demoStarted = false;
      throw err;
    });
};
root.render(app(0, true, demo));
